import { useEffect } from 'react'

import { InformationAPI } from '@builddocs/data-management-rest'
import { useMatch } from 'react-router'
import { create } from 'zustand'

type CryptographyVersion = 'v1' | 'v2'
type PoaIsEnabled = boolean

interface CryptographyVersionStore {
  version: CryptographyVersion
  poaIsEnabled: PoaIsEnabled
  setVersion: (version: CryptographyVersion) => void
  setPoaIsEnabled: (poaIsEnabled: PoaIsEnabled) => void
}

const useCryptographyVersionStore = create<CryptographyVersionStore>(set => ({
  version: 'v1',
  poaIsEnabled: false,
  setVersion: version => set({ version }),
  setPoaIsEnabled: poaIsEnabled => set({ poaIsEnabled }),
}))

export const useVersionOf = () => {
  const { version, setVersion, poaIsEnabled, setPoaIsEnabled } =
    useCryptographyVersionStore()

  const match = useMatch('projects/:projectId/*')

  const projectId = match?.params.projectId

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const data = await InformationAPI.get('/ft', {
          params: {
            projectId,
          },
        }).then(res => res.data)

        if (data.cryptographyVersion || data.poaIsEnabled) {
          setVersion(data.cryptographyVersion)
          setPoaIsEnabled(data.poaIsEnabled === 'true')
        }
      } catch (error) {
        console.error('Failed to fetch cryptography version:', error)
        // Keep v2 as default in case of error
      }
    }

    fetchVersion()
  }, [setVersion, setPoaIsEnabled, projectId])

  return {
    cryptography_version: version,
    poaIsEnabled,
  }
}
